import { validate_non_empty_string, validate_non_sub_zero_number } from '@/utils/validations/validate_inputs';

export default {
  methods: {
    validate_create_trust_type_inputs(skip_manual_fields = false) {
      if (!skip_manual_fields) {
        const is_review_stage = this.create_modal_stage === 'extracted';
        const name = is_review_stage ? this.create_job_title : this.trust_type_name;
        const extracted_purpose = is_review_stage
          ? (this.create_job_sections || []).find((section) => String(section?.title || '').startsWith('B.'))
            ?.descriptions?.find((value) => validate_non_empty_string(value))
          : '';
        const description = is_review_stage
          ? this.create_job_description || this.trust_type_description || extracted_purpose
          : this.trust_type_description;

        if (!validate_non_empty_string(name)) {
          this.show_error('Job title must not be empty');
          return false;
        }
        if (!validate_non_empty_string(description)) {
          this.show_error('Job description must not be empty');
          return false;
        }
      }
      if (!validate_non_sub_zero_number(parseInt(this.project_id, 10))) {
        this.show_error('Project Id must not be null');
        return false;
      }
      return true;
    },

    validate_edit_trust_type_inputs() {
      if (!validate_non_empty_string(this.edit_trust_type_name)) {
        this.show_error('Entity type name must not be empty');
        return false;
      }
      if (!validate_non_sub_zero_number(parseInt(this.edit_trust_type_id, 10))) {
        this.show_error('Entity type id must not be null');
        return false;
      }
      return true;
    },

    extract_error_from_response(response_data) {
      if (Array.isArray(response_data.errors) && response_data.errors.length > 0) {
        return this.safe_array_get(response_data.errors, 0);
      }
      return response_data.detail || response_data.message || JSON.stringify(response_data);
    },

    extract_error_message(error) {
      if (!error) return "Unknown error occurred.";
      if (error?.response?.data) return this.extract_error_from_response(error.response.data);
      return error?.message || "Request failed. Please try again.";
    },
  },
};
